import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router } from '@angular/router';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;


@Component({
  selector: 'app-verifymail',
  templateUrl: './verifymail.component.html',
  styleUrls: ['./verifymail.component.scss']
})
export class VerifymailComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public currentUrl:any ='';
  public token:any='';
  public usertYpes:any=1;
  public verificationResult: '' | 'success' | 'failed' = '';
  public verificationMessage: string = '';

  constructor(public router: Router, private service: GlobalService) {   
  }

  get isStripeConfirmation(): boolean {
    return this.currentUrl == '/confirmation-account-verification'
      || this.currentUrl == '/success-account-verification'
      || this.currentUrl == '/failed-account-verification';
  }

  ngOnInit(): void {
    var mm:any =(this.router.url).split('/');  
    this.currentUrl ='/'+ mm[1];
    if(mm.length ==3){
      if( mm[2].includes("?")){
        var ss:any=mm[2].split('?')
        this.token = ss[0];
        var ssd:any= ss[1].split('=');
        this.usertYpes=ssd[1];
      } else {
        this.token = mm[2];
      }
      if(this.currentUrl == '/verify-email'   || this.currentUrl == '/verify-email-mobile' ){
        localStorage.setItem('grw_upload_iamge','1');
        this.OnReset();
      } else if (this.isStripeConfirmation) {
        this.verifyStripeAccount();
      }
    }
  }

  OnReset(){ 
    this.submitted = true;
    this.loading = true;
    const url = "/verify-email";
    const detail = {
      "verification_token":this.token,
    };
    this.service.PostApis(detail,url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.submitted = false;
        this.service.successAlert(response.message);
        localStorage.setItem('grw_login',<any> JSON.stringify(response.data || {}));
        this.service.setSubject(response.data);
        localStorage.setItem('grw_token',response.data.token);
        this.loading = false;
      } else {
        this.service.dangerAlert(response.message);
        this.loading = false;
      }
    }), (error) => { this.loading =false; });
  }

  verifyStripeAccount() {
    this.loading = true;
    this.verificationResult = '';
    this.verificationMessage = '';
    const url = '/confirmation-account-verification?stripe_token=' + encodeURIComponent(this.token);
    this.service.GetApi(url).subscribe((response: any) => {
      this.loading = false;
      if (response.success == 1) {
        this.verificationResult = 'success';
        this.verificationMessage = response.message || '';
        this.updateLoginStripeStatus(true, response.data);
        setTimeout(() => {
          this.router.navigate(['/presentation']);
        }, 1500);
      } else {
        this.verificationResult = 'failed';
        this.verificationMessage = response.message || 'We aren\'t able to connect with your Stripe account.';
        this.updateLoginStripeStatus(false);
      }
    }, () => {
      this.loading = false;
      this.verificationResult = 'failed';
      this.verificationMessage = 'We aren\'t able to connect with your Stripe account.';
      this.updateLoginStripeStatus(false);
    });
  }

  private updateLoginStripeStatus(verified: boolean, stripeData: any = {}): void {
    const login: any = getLocalJSON('grw_login', {});
    login.stripe_account_verify = verified;
    if (login.stripeDetail) {
      login.stripeDetail.detail_submitted = verified;
      if (stripeData?.country) {
        login.stripeDetail.country = stripeData.country;
      }
      if (stripeData?.default_currency) {
        login.stripeDetail.currency = (stripeData.default_currency || '').toString().toUpperCase();
      }
    }
    if (verified) {
      if (stripeData?.userCurrency) {
        login.userCurrency = stripeData.userCurrency;
      } else if (stripeData?.default_currency) {
        login.userCurrency = (stripeData.default_currency || '').toString().toUpperCase();
      }
      if (stripeData?.userCurrencySymbol) {
        login.userCurrencySymbol = stripeData.userCurrencySymbol;
      }
      if (login.userCurrency) {
        localStorage.setItem('grw_logincurrency', login.userCurrency);
      }
      if (login.userCurrencySymbol) {
        localStorage.setItem('grw_currencySymbol', login.userCurrencySymbol);
      }
    }
    localStorage.setItem('grw_login', JSON.stringify(login));
    this.service.setSubject(login);
  }

}
